import mime from 'mime-types'

// leave the export, even if you don't use it
export default ({ app, router, Vue }) => {
  Vue.prototype.$mime = mime
}
